var App = App || {};

App.CookieNotice = (function () {
    'use strict';

    const cookieName = "MainstreetCU_CookieNotice";
    const cookieValue = "confirmed";

    /* =========================================================================
    Initialization
    ========================================================================= */

    // Initializes the cookie notice by binding the confirm button event if the notice element exists.
    function initializeCookieNotice(cookieNoticeId) {

        const cookieNoticeElement = document.getElementById(cookieNoticeId);
        if (!cookieNoticeElement) return;

        bindConfirmButton(cookieNoticeElement);
    }

    /* =========================================================================
    Event Binding
    ========================================================================= */

    // Binds the click event to the confirm button, triggering cookie consent and notice removal.
    const bindConfirmButton = (cookieNoticeElement) => {

        const confirmButtonElement = cookieNoticeElement.querySelector("[data-cookienotice='confirm']");
        if (!confirmButtonElement) return;

        confirmButtonElement.addEventListener("click", function () {
            cookieNoticeClose(cookieNoticeElement);
        });
    };

    /* =========================================================================
    UI Synchronization
    ========================================================================= */

    // Sets the consent cookie, adds a confirmation class, and removes the notice after transition.
    const cookieNoticeClose = (cookieNoticeElement) => {
        App.Cookies.setCookie(cookieName, cookieValue, Infinity, "/", window.location.hostname, window.location.protocol === "https:");

        cookieNoticeElement.classList.add('cookieNotice--confirmed');
        cookieNoticeElement.addEventListener('transitionend', () => {
            cookieNoticeElement.remove();
        });

    };

    /* =========================================================================
    Public API Exposure
    ========================================================================= */

    return {
        initializeCookieNotice
    };

})();